import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationsState } from './applications.state';

/**
 * Selectors make more convenient to slice and get store values.
 *
 * Since the application is divided into modules, each module has its own part of store.
 * See applications.module.ts:
 * ```
 * StoreModule.forFeature('applications', applications),
 * ```
 *
 * These selectors are used to make more easy to select slices of store with regard to application module.
 */

export const selectApplicationsModule = createFeatureSelector<ApplicationsState>('applications');

// ---------------------------------------------------------------------------------------------------------------------

export const selectEnabledApplicationList = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state.enabledApplicationList);

export const selectEnabledApplicationParams = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state.enabledApplicationParams);

export const selectExpandedApplicationList = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state.expandedApplicationList);

export const selectApplicationDetails = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state.applicationDetails);

export const selectBackupApplicationDetails = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state.backupApplicationDetails);

// ---------------------------------------------------------------------------------------------------------------------

export const selectLoadingStatus = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state ? state.loadingStatus : null);

export const selectLoadingError = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state ? state.loadingError : null);

// ---------------------------------------------------------------------------------------------------------------------

export const selectUpdatePermissions = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state.updatePermissions);

export const selectUpdatePermissionsAuthorization = createSelector(selectApplicationsModule,
    (state: ApplicationsState) => state.updatePermissions ? state.updatePermissions.authorization : null);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/application.selector.ts